import { render, staticRenderFns } from "./dAlertError.vue?vue&type=template&id=5cf52ced&scoped=true&"
import script from "./dAlertError.vue?vue&type=script&lang=js&"
export * from "./dAlertError.vue?vue&type=script&lang=js&"
import style0 from "./dAlertError.vue?vue&type=style&index=0&id=5cf52ced&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf52ced",
  null
  
)

export default component.exports